module.exports = __webpack_public_path__ + "static/media/S_F02.9626e071.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/RED/S_F02.png
// module id = 133
// module chunks = 0